import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AddNewSectionLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'AddNewSection' */ './components/AddNewSectionV2'
		)
);

export default (store) => {
	return {
		path: 'section-setup/:campusId?/create-new-section',
		element: <AsyncLoading component={<AddNewSectionLazy />} />,
	};
};
